'use client';
import More from '@/app/_components/ui/icons/More.svg';
import Close from '@/app/_components/ui/icons/Close.svg';
import Image from 'next/image';
import { useState } from 'react';
import Modal from 'react-modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/virtual';
import Img from '../share/Img';

export default function ProductImageGallery({ images, productName }) {
  const [currentImage, setCurrentImage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [swiperRef, setSwiperRef] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);

  const slideTo = (index) => {
    swiperRef.slideTo(index, 0);
    setSelectedImage(index);
  };

  const onClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      {images.length > 0 ? (
        <>
          <div className="hidden lg:block">
            <div className="relative  w-full overflow-hidden  max-w-6xl mx-auto border border-light-gray-200 rounded-md">
              <Image
                src={images[currentImage].full_path}
                alt={productName}
                placeholder="blur"
                blurDataURL="/images/no-image.jpg"
                width={720}
                height={660}
                loading="eager"
                priority
              />
            </div>
            <div className="flex mt-4 gap-x-2">
              {images.map((image, index) => {
                if (index < 3) {
                  return (
                    <div
                      key={index}
                      className={`relative h-[84px] w-[84px]  cursor-pointer border border-transparent rounded-md overflow-hidden ${
                        index === currentImage
                          ? ' border-ocean-blue-900 '
                          : 'border-light-gray-200'
                      }`}
                      onClick={() => setCurrentImage(index)}
                    >
                      <Image
                        src={image.full_path}
                        width={84}
                        height={84}
                        alt={image?.alt}
                        placeholder="blur"
                        blurDataURL="/images/no-image.jpg"
                        loading="eager"
                        fetchPriority="low"
                      />
                    </div>
                  );
                }
              })}
              {images.length > 3 && (
                <>
                  <div
                    // key={index}
                    className="relative h-[84px] w-[84px] p-2 cursor-pointer border border-light-gray-300 rounded-md overflow-hidden"
                    onClick={() => setOpenModal(true)}
                  >
                    <div className="p-2">
                      <Image
                        src={images[3].full_path}
                        width={84}
                        height={84}
                        alt={images[3].alt}
                        title={images[3].title}
                        placeholder="blur"
                        blurDataURL="/images/no-image.jpg"
                        className="blur"
                        loading="eager"
                        fetchPriority="low"
                      />
                    </div>

                    <div className="absolute top-7 left-7">
                      <More />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="lg:hidden border border-light-gray rounded-md mb-6">
            <Swiper
              pagination={true}
              modules={[Pagination]}
              className="mySwiper"
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="relative h-auto w-full text-center">
                    <Image
                      src={image.full_path}
                      width="720"
                      height="660"
                      alt={image?.alt}
                      placeholder="blur"
                      blurDataURL="/images/no-image.jpg"
                      loading="eager"
                      fetchPriority="low"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <Modal
            isOpen={openModal}
            onRequestClose={onClose}
            ariaHideApp={false}
            portalClassName="modalAddComment"
            className="commentModal"
            overlayClassName="modalOverlay"
            style={{
              content: {
                'max-width': '872px',
                background: '#fff',
                border: '1px solid #DADADA',
                borderRadius: '15px',
                overflowY: 'hidden',
              },
            }}
          >
            <div className=" modal-header p-5 pb-1 flex justify-between">
              <h2>تصاویر محصول</h2>
              <button onClick={onClose}>
                <Close />
              </button>
            </div>
            <div className="pt-2 pb-4">
              <div className="w-full border-t border-light-gray-200"></div>
            </div>
            <div className="popupGalleryWrap p-6 ">
              <div className="flex -mx-3">
                <div className="w-[60%] px-3  rounded-md">
                  <Swiper
                    onSwiper={setSwiperRef}
                    slidesPerView={1}
                    centeredSlides={true}
                    spaceBetween={30}
                    pagination={{
                      type: 'fraction',
                    }}
                    navigation={true}
                    Virtual
                    modules={[Virtual]}
                  >
                    {images.map((image, index) => (
                      <SwiperSlide key={index} virtualIndex={index}>
                        <Img image={image} width={720} height={660} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="w-[40%] px-3">
                  <div className="mb-2">{productName}</div>
                  <p className="append-buttons flex flex-wrap">
                    {images.map((image, index) => (
                      <div
                        className={` border-2 m-1 flex border-light-gray-300 rounded-md overflow-hidden ${
                          selectedImage == index
                            ? 'border-ocean-blue'
                            : 'border-light-gray-300'
                        }`}
                        key={index}
                      >
                        <Image
                          src={image.full_path}
                          onClick={() => slideTo(index)}
                          width="80"
                          height="80"
                          alt={image?.alt}
                        />
                      </div>
                    ))}
                  </p>
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <div>
          <Image
            src="images/no-image.jpg"
            width={720}
            height={660}
            alt={'no image'}
          />
        </div>
      )}
    </>
  );
}
